<template>
    <v-card :loading="loading" width="450">
        <v-card-title>
            <TitleOfDialog title="Edit Mission" @close="emit('close')"></TitleOfDialog>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
            <v-form ref="missionForm">
                <v-text-field color="primary" type="text" label="Name" id="name" name="name" v-model="editMission.name"
                    required :rules="nameRules"></v-text-field>
                <v-text-field color="primary" type="text" label="Location" id="location" name="location"
                    v-model="editMission.location" required :rules="locationRules"></v-text-field>
                <v-textarea color="primary" label="Description" id="description" name="description"
                    v-model="editMission.description" required :rules="descriptionRules"></v-textarea>
                <v-checkbox color="primary" name="public_mission" label="Is Mission public?" id="public_mission"
                    v-model="editMission.is_public"></v-checkbox>
                <v-checkbox color="primary" name="active_mission" label="Is Mission active?" id="active_mission"
                    v-model="editMission.active_mission"></v-checkbox>
            </v-form>
        </v-card-text>
        <v-card-actions>
            <v-btn @click="validate()" class="w-100" color="primary" variant="elevated" text="Edit mission"></v-btn>
        </v-card-actions>
    </v-card>

</template>


<script setup>
import TitleOfDialog from '@/components/base/TitleOfDialog.vue';
import { onMounted, ref } from 'vue';
import { useMissionStore } from '@/store/missionStore';
import { descriptionRules, nameRules, locationRules } from './rules/mission';


const missionStore = useMissionStore();
const loading = ref(false);
const emit = defineEmits(['close']);

const props = defineProps({
    mission: Object
})

const editMission = ref({
    name: props.mission.name,
    description: props.mission.description,
    location: props.mission.location,
    active_mission: Boolean(props.mission.active_mission),
    is_public: Boolean(props.mission.is_public)
});

const missionForm = ref();


const validate = async () => {
    const isValid = await missionForm.value?.validate();
    if (isValid.valid) {
        loading.value = true;
        try {
            const formattedMission = {
                ...editMission.value,
                active_mission: editMission.value.active_mission ? 1 : 0,
                is_public: editMission.value.is_public ? 1 : 0
            };
            await missionStore.editMission(formattedMission, props.mission.id);
            loading.value = false;
            emit('close');
        } catch (error) {
            loading.value = false;
            console.error("Error en la validación o creación de la mision:", error);
        }
    } else {
        console.log("Formulario no válido:", isValid);
    }
}


</script>